export default __webpack_public_path__ + "static/media/products_531.60415fa6.jpg";